import App from './App'
import AWSSuite from './services/aws-suite'
import BootstrapVue from 'bootstrap-vue'
import router from './router'
import Vue from 'vue'
import VueDialog from 'vuejs-dialog'
import VueLogger from 'vuejs-logger'
import VueModal from 'vue-js-modal'
import VueMoment from 'vue-moment'
import VueNotification from 'vue-notification'
import VueResource from 'vue-resource'
import VueGoodTable from 'vue-good-table'
import VeeValidate from 'vee-validate'
import VueNativeNotification from 'vue-native-notification'

Vue.config.productionTip = false

Vue.use(VueModal)
Vue.use(VueDialog)
Vue.use(VueGoodTable)
Vue.use(VueMoment)
Vue.use(VueNotification)
Vue.use(VueNativeNotification, { requestOnNotify: true })
Vue.use(VueResource)
Vue.use(BootstrapVue)
Vue.use(VueLogger, { logLevel: 'debug' })
Vue.use(AWSSuite, {
  clientId: '281589362472-i3fmfnuuet0it2bah3vo9deqro8oltmq.apps.googleusercontent.com',
  identityPoolId: 'us-east-1:2278b4c1-8c54-4b64-96a0-e1a62db74733'
})
Vue.use(VeeValidate)

// eslint-disable-next-line
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js